import ResourceList from './List';

const resource = {
    list: ResourceList
};

export default resource;